package shared.model.feature.post.domain

data class PostCreatorTag(
    val id: String,
    val creatorId: String,
    val name: String,
    val hexColor: String,
)
